import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Select from "react-select";
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, Row } from 'reactstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../components/common/bread-crumb";
import GridEmployee from '../../components/employee/grid_employee';
import { handlerRespError } from '../../components/utility/handler_resp';
import ConfigData from '../../config.json';
import Swal from 'sweetalert2';

const EmployeeList = () => {
    const [dataEmployees, setDataEmployees] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [selectBusinessUnit, setSelectBusinessUnit] = useState(null);
    const [ddlBusinessUnit, setDdlBusinessUnit] = useState([]);
    const [selectDepartment, setSelectDepartment] = useState(null);
    const [ddlDepartment, setDdlDepartment] = useState([]);
    const [selectSubDepartment, setSelectSubDepartment] = useState(null);
    const [ddlSubDepartment, setDdlSubDepartment] = useState([]);
    const [selectDivision, setSelectDivision] = useState(null);
    const [ddlDivision, setDdlDivision] = useState([]);
    const [selectSubDivision, setSelectSubDivision] = useState(null);
    const [ddlSubDivision, setDdlSubDivision] = useState([]);
    const [selectSection, setSelectSection] = useState(null);
    const [ddlSection, setDdlSection] = useState([]);
    const [selectSubSection, setSelectSubSection] = useState(null);
    const [ddlSubSection, setDdlSubSection] = useState([]);
    const [txtSearch, setTxtSearch] = useState("");
    const [isShowModalTerminate, setIsShowModalTerminate] = useState(false);
    const [dataTerminate, setDataTerminate] = useState({
        id: 0,
        termination_date: ""
    });
    const history = useHistory();

    useEffect(() => {
        LoadDataGrid();
        LoadDataBusinessUnit();
        LoadDataDepartment();
        LoadDataSubDepartment();
        LoadDataDivision();
        LoadDataSubDivision();
        LoadDataSection();
        LoadDataSubSection();
    }, []);

    const onClickSearch = () => {
        let arrSearch = dataEmployees;
        if(selectBusinessUnit != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_business_unit.toString() === selectBusinessUnit.value;
            });
        }
        if(selectDepartment != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_department.toString() === selectDepartment.value;
            });
        }
        if(selectSubDepartment != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_sub_department.toString() === selectSubDepartment.value;
            });
        }
        if(selectDivision != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_division.toString() === selectDivision.value;
            });
        }
        if(selectSubDivision != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_sub_division.toString() === selectSubDivision.value;
            });
        }
        if(selectSection != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_section.toString() === selectSection.value;
            });
        }
        if(selectSubSection != null){
            arrSearch = arrSearch.filter((item) => {
                return item.id_sub_section.toString() === selectSubSection.value;
            });
        }
        if(txtSearch !== null && txtSearch !== ""){
            arrSearch = arrSearch.filter((item) => {
                let dataMap = item.name_th + " " + item.surname_th + " " + item.name_en + " " + item.surname_en + " " + item.email + " " + item.phone_number + " " + item.name_position + " " + item.employee_id;
                dataMap = dataMap.toLowerCase();
                return dataMap.includes(txtSearch.toLowerCase());
            });
        }
        OnSort(arrSearch);
    };

    const onClickClear = () => {
        setSelectBusinessUnit(null);
        setSelectDepartment(null);
        setSelectSubDepartment(null);
        setSelectDivision(null);
        setSelectSubDivision(null);
        setSelectSection(null);
        setSelectSubSection(null);
        setTxtSearch("");
        OnSort(dataEmployees);
    };

    const onClickTerminate = (id) => {
        setDataTerminate({
            id: id,
            termination_date: ""
        });
        setIsShowModalTerminate(!isShowModalTerminate);
    };

    const LoadDataGrid = () => {
        let url = ConfigData.API_URL + "employee-general/grid?status=1";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataEmployees(respData.data);
                OnSort(respData.data);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlBusinessUnit(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDepartment = () => {
        let url = ConfigData.API_URL + "department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                    };
                });
                setDdlDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubDepartment = () => {
        let url = ConfigData.API_URL + "sub-department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                    };
                });
                setDdlSubDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDivision = () => {
        let url = ConfigData.API_URL + "division/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                    };
                });
                setDdlDivision(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubDivision = () => {
        let url = ConfigData.API_URL + "sub-division/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                    };
                });
                setDdlSubDivision(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSection = () => {
        let url = ConfigData.API_URL + "section/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                        id_sub_division: e.id_sub_division.toString(),
                    };
                });
                setDdlSection(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubSection = () => {
        let url = ConfigData.API_URL + "sub-section/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                        id_sub_division: e.id_sub_division.toString(),
                        id_section: e.id_section.toString(),
                    };
                });
                setDdlSubSection(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const OnSort = (arrData) => {
        let dataSort = SortData(arrData, "employee_id", "asc");
        setGridData(dataSort);
    };

    const SortData = (data, field, order) => {
        const sorted = [...data].sort((a, b) => {
            if (a[field] === null) return 1;
            if (b[field] === null) return -1;
            if (a[field] === null && b[field] === null) return 0;
            return (
                a[field].toString().localeCompare(
                    b[field].toString(), 
                    "en", 
                    {
                        numeric: true,
                    }
                ) * (order === "asc" ? 1 : -1)
            );
        });
        return sorted;
    }

    const SaveDataTerminate = (values) => {
        let url = ConfigData.API_URL + "employee-general/termination/" + values.id + "?termination_date=" + values.termination_date;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataGrid();
                setIsShowModalTerminate(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Ternimate employee success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to ternimate employee.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const validateTerminate = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataTerminate.id || 0,
            termination_date: dataTerminate.termination_date || "",
        },
        validationSchema: Yup.object({
            termination_date: Yup.string().required("Please enter a Effective date."),
        }),
        onSubmit: SaveDataTerminate
    });

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="" pageTitle="Employee management"/>
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={12} md={3} className='mb-2'>
                                            <Select id="ddlBusinessUnit"
                                                name="ddlBusinessUnit"
                                                value={selectBusinessUnit}
                                                onChange={(selected) => {
                                                    setSelectBusinessUnit(selected);
                                                }}
                                                options={ddlBusinessUnit}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Business unit"
                                            />
                                        </Col>
                                        <Col sm={12} md={3} className='mb-2'>
                                            <Select id="ddlDepartment"
                                                name="ddlDepartment"
                                                value={selectDepartment}
                                                onChange={(selected) => {
                                                    setSelectDepartment(selected);
                                                }}
                                                options={ddlDepartment}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Department"
                                            />
                                        </Col>
                                        <Col sm={12} md={2} className='mb-2'>
                                            <Select id="ddlSubDepartment"
                                                name="ddlSubDepartment"
                                                value={selectSubDepartment}
                                                onChange={(selected) => {
                                                    setSelectSubDepartment(selected);
                                                }}
                                                options={ddlSubDepartment}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Sub department"
                                            />
                                        </Col>
                                        <Col sm={12} md={2} className='mb-2'>
                                            <Select id="ddlDivision"
                                                name="ddlDivision"
                                                value={selectDivision}
                                                onChange={(selected) => {
                                                    setSelectDivision(selected);
                                                }}
                                                options={ddlDivision}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Division"
                                            />
                                        </Col>
                                        <Col sm={12} md={2} className='mb-2'>
                                            <Select id="ddlSubDivision"
                                                name="ddlSubDivision"
                                                value={selectSubDivision}
                                                onChange={(selected) => {
                                                    setSelectSubDivision(selected);
                                                }}
                                                options={ddlSubDivision}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Sub division"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} md={3} className='mb-2'>
                                            <Select id="ddlSection"
                                                name="ddlSection"
                                                value={selectSection}
                                                onChange={(selected) => {
                                                    setSelectSection(selected);
                                                }}
                                                options={ddlSection}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Section"
                                            />
                                        </Col>
                                        <Col sm={12} md={3} className='mb-2'>
                                            <Select id="ddlSubSection"
                                                name="ddlSubSection"
                                                value={selectSubSection}
                                                onChange={(selected) => {
                                                    setSelectSubSection(selected);
                                                }}
                                                options={ddlSubSection}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Sub section"
                                            />
                                        </Col>
                                        <Col sm={12} md={4} className='mb-2'>
                                            <div className="form-icon right">
                                                <Input className="form-control" type="text" id="txtSerachTable" placeholder="Search" value={txtSearch || ""} onChange={(e) => { setTxtSearch(e.target.value); }} />
                                                <i className="ri-search-2-line"></i>
                                            </div>
                                        </Col>
                                        <Col sm={12} md={2} className='mb-2'>
                                            <div className='hstack gap-3'>
                                                <Button color="light" onClick={onClickClear}>Clear</Button>
                                                <Button color="primary" onClick={onClickSearch}>Filter</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <GridEmployee data={gridData} rowPerPage={40} onClickTerminate={onClickTerminate} />

                     {/* Modal Terminate Employee */}
                     <Modal id="modalTerminateEmployee"
                        isOpen={isShowModalTerminate}
                        toggle={() => { setIsShowModalTerminate(!isShowModalTerminate); }}
                        backdrop={'static'}
                        centered
                     >
                        <ModalBody>
                            <Row>
                                <Col lg={12}>
                                    <Form className="needs-validation"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validateTerminate.handleSubmit();
                                            return false;
                                        }}
                                    >
                                        <Row>
                                            <Col lg={12}>
                                                <p className="label-terminate mb-0">Terminate this account ?</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label className="label-terminate-desc" htmlFor="txtTerminateDate">Choose an effective date.</Label>
                                                    <Input id="txtTerminateDate" 
                                                        name="termination_date"
                                                        placeholder="Effective date"
                                                        type="date"
                                                        className="from-control"
                                                        onChange={validateTerminate.handleChange}
                                                        onBlur={validateTerminate.handleBlur}
                                                        value={validateTerminate.values.termination_date || ""}
                                                        invalid={ validateTerminate.touched.termination_date && validateTerminate.errors.termination_date ? true : false }
                                                    />
                                                    { validateTerminate.touched.termination_date && validateTerminate.errors.termination_date ? 
                                                        ( <FormFeedback type="invalid">{validateTerminate.errors.termination_date}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <Button color="light" type="button" onClick={() => setIsShowModalTerminate(false) } >
                                                    Close
                                                </Button>
                                                <Button className="float-end" color="success" type="submit">
                                                    Save
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </ModalBody>
                     </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default EmployeeList;